import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from "vue";
import { BFormCheckbox, BFormRadio } from "bootstrap-vue";
import { getAllValues } from "./utilities";
import FormDrilldownList from "./FormDrilldownList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDrilldownOption',
    props: {
        currentValue: null,
        option: null,
        handleClick: null,
        multiple: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const showChildren = ref(false);
        const hasOptions = computed(() => {
            return props.option.options.length > 0;
        });
        // indicates if the value has been selected or not
        const isChecked = computed(() => {
            const optionValue = props.option.value;
            return props.currentValue.includes(optionValue);
        });
        // determine required input element type
        const isComponent = computed(() => {
            return props.multiple ? BFormCheckbox : BFormRadio;
        });
        function toggleChildren() {
            showChildren.value = !showChildren.value;
        }
        function toggleInitialization() {
            const childValues = getAllValues(props.option.options);
            for (const childValue of childValues) {
                if (props.currentValue.includes(childValue)) {
                    showChildren.value = true;
                    break;
                }
            }
        }
        onMounted(() => {
            toggleInitialization();
        });
        return { __sfc: true, props, showChildren, hasOptions, isChecked, isComponent, toggleChildren, toggleInitialization, FormDrilldownList };
    }
});
